import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { toast } from 'react-toastify';
import { Router } from 'react-router-dom';
import history from './services/history';
import { GlobalContextProvider } from './globalContext';
import Routes from './Routes';
import * as serviceWorker from './serviceWorker';
import 'react-toastify/dist/ReactToastify.min.css';
import 'assets/scss/app.scss';

if (process.env.NODE_ENV === 'development') {
    const whyDidYouRender = require('@welldone-software/why-did-you-render');
    whyDidYouRender(React);
}

toast.configure({
    autoClose: 5000,
    position: 'bottom-right',
    draggable: false,
});

ReactDOM.render(
    <GlobalContextProvider>
        <Router history={history}>
            <Routes />
        </Router>
    </GlobalContextProvider>,
    document.getElementById('root'),
);

serviceWorker.unregister();
